const domContentLoadedCallbacks: (() => void)[] = [];

// ----------------------------------------------------------------------------

function onDOMContentLoaded(callback: () => void): void {
    if (document.readyState === 'loading') {
        if (!domContentLoadedCallbacks.length) {
            document.addEventListener(
                'DOMContentLoaded',
                (): any => {
                    for (const currentCallback of domContentLoadedCallbacks) {
                        currentCallback();
                    }

                    domContentLoadedCallbacks.length = 0;
                },
                { once: true },
            );
        }

        domContentLoadedCallbacks.push(callback);
        return;
    }

    callback();
}

// ----------------------------------------------------------------------------

export { onDOMContentLoaded };
